import React from 'react';
import Loader from 'src/components/Loader/Loader';
import Seperator from 'src/components/Seperator/seperator';
import { CanonicalContact } from '../helpers/contactShape';
import ContactRow from './ContactRow';
import './LegacyContactPickerPanel.scss';

interface LegacyContactPickerPanelProps {
  isLoading: boolean;
  propertyContacts: CanonicalContact[];
  allContacts: CanonicalContact[];
  subtitleVariant: 'role-only' | 'role-and-services';
  onSelectContact: (contact: CanonicalContact) => void;
}

const LegacyContactPickerPanel = ({
  isLoading,
  propertyContacts,
  allContacts,
  subtitleVariant,
  onSelectContact,
}: LegacyContactPickerPanelProps) => {
  if (isLoading) {
    return (
      <div className="legacy-contact-picker-panel">
        <div className="loader-wrap">
          <Loader imageHeight="80px" imageWidth="80px" />
        </div>
      </div>
    );
  }

  return (
    <div className="legacy-contact-picker-panel">
      <div className="legacy-section-header">
        Service Providers Associated with this Property
      </div>

      {propertyContacts.length > 0 ? (
        propertyContacts.map((contact: CanonicalContact) => (
          <ContactRow
            key={contact.id}
            contact={contact}
            onSelect={onSelectContact}
            subtitleVariant={subtitleVariant}
          />
        ))
      ) : (
        <div className="legacy-section-empty">
          No service providers are associated with this property.
        </div>
      )}

      <Seperator />

      {allContacts.length > 0 && (
        <>
          <div className="legacy-section-header">
            Service Providers not associated with this Property
          </div>

          {allContacts.map((contact: CanonicalContact) => (
            <ContactRow
              key={contact.id}
              contact={contact}
              onSelect={onSelectContact}
              subtitleVariant={subtitleVariant}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default LegacyContactPickerPanel;
